import { render, staticRenderFns } from "./TrainerReviews.vue?vue&type=template&id=5e453004&scoped=true&"
import script from "./TrainerReviews.vue?vue&type=script&lang=js&"
export * from "./TrainerReviews.vue?vue&type=script&lang=js&"
import style0 from "./TrainerReviews.vue?vue&type=style&index=0&id=5e453004&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e453004",
  null
  
)

export default component.exports